var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChoiceCupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFE083"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 27C20.6863 27 18 24.3137 18 21V15.4444C18 15.0306 18 14.8237 18.0603 14.658C18.1614 14.3802 18.3802 14.1614 18.658 14.0603C18.8237 14 19.0306 14 19.4444 14H28.5556C28.9694 14 29.1763 14 29.342 14.0603C29.6198 14.1614 29.8386 14.3802 29.9397 14.658C30 14.8237 30 15.0306 30 15.4444V21C30 24.3137 27.3137 27 24 27ZM24 27V30M30 16H32.5C32.9659 16 33.1989 16 33.3827 16.0761C33.6277 16.1776 33.8224 16.3723 33.9239 16.6173C34 16.8011 34 17.0341 34 17.5V18C34 18.93 34 19.395 33.8978 19.7765C33.6204 20.8117 32.8117 21.6204 31.7765 21.8978C31.395 22 30.93 22 30 22M18 16H15.5C15.0341 16 14.8011 16 14.6173 16.0761C14.3723 16.1776 14.1776 16.3723 14.0761 16.6173C14 16.8011 14 17.0341 14 17.5V18C14 18.93 14 19.395 14.1022 19.7765C14.3796 20.8117 15.1883 21.6204 16.2235 21.8978C16.605 22 17.07 22 18 22M19.4444 34H28.5556C28.801 34 29 33.801 29 33.5556C29 31.5919 27.4081 30 25.4444 30H22.5556C20.5919 30 19 31.5919 19 33.5556C19 33.801 19.199 34 19.4444 34Z",
    stroke: "#414651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoiceCupIcon);
export default __webpack_public_path__ + "static/media/choice-cup-icon.14912f82cc9c0a16a800424bf2d823fc.svg";
export { ForwardRef as ReactComponent };